import * as service from 'services/dashboard.service';
// import * as session from 'services/session.service';
import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work

import {
    GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE,
    GET_TOTAL_COUNTS_REQUESTED_PROFILE,
    GET_TOTAL_COUNTS_FAILED_PROFILE,
    INCREASE_CONTACT_COUNT,
} from 'containers/Profile-view/actionTypes';

import { REQUESTED, FAILED, SUCCESSFUL, UPDATE_FILTER, SUCCESSFUL_POSTINGS,
    SUCCESSFUL_REQUESTS, LOADING, INIT, GET_TOTAL_COUNTS_REQUESTED, GET_TOTAL_COUNTS_SUCCESSFULL,
    GET_TOTAL_COUNTS_FAILED, REMOVE_LOADER, ADD_STUDENT_CURRENT_DIVISION,
  ADD_CURRENT_DIVISION_FAILED, ADD_CURRENT_DIVISION_REQUESTED, REQUEST_VIEWED_COUNT_REQUESTED,
  REQUEST_VIEWED_COUNT_SUCCESSFUL, REQUEST_VIEWED_COUNT_FAILED,
} from './actionTypes';

// import { congnitoSyncHandler } from './synchandler';

export function getSchools(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.getSchools(payload)
          .then((data) => {
            if (data) {
              dispatch({
                type: SUCCESSFUL,
                schools: fromJS(data),
              });
            }
          })
          .catch((err) => {
            dispatch({
              type: FAILED,
              error: err,
            });
          });
  };
}


export function getPostings(payload) {
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.getPostings(payload)
          .then((data) => {
            if (data) {
              dispatch({
                type: SUCCESSFUL_POSTINGS,
                postings: fromJS(data),
              });
              dispatch({
                type: REMOVE_LOADER,
              });
            }
          })
          .catch((err) => {
            dispatch({
              type: FAILED,
              error: err,
            });
          });
  };
}


export function initProfile(profile) {
  return (dispatch) => {
    dispatch({
      type: INIT,
      profile,
    });
  };
}
export function getRequests(id) {
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.getRequests(id)
            .then((data) => {
              if (data) {
                dispatch({
                  type: SUCCESSFUL_REQUESTS,
                  requests: fromJS(data),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}

export function updateFilter(filter) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILTER,
      filter,
    });
  };
}

export function addToList(payload, action, attrib) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.addToWishList(payload)
            .then((data) => {
              if (data) {
                dispatch({
                  type: LOADING,
                });
                dispatch({
                  type: action,
                  list: fromJS(data[attrib]),
                });
                dispatch({
                  type: INCREASE_CONTACT_COUNT,
                  profile: fromJS(data),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}

export function removeFromList(payload, action, attrib) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.removeFromList(payload)
            .then((data) => {
              if (data) {
                dispatch({
                  type: LOADING,
                });
                dispatch({
                  type: action,
                  list: fromJS(data[attrib]),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}

export function addToRequest(payload, action) {
  // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service
      .addToRequest(payload)
      .then((data) => {
        if (data) {
          // console.log('data:', fromJS(data));
          dispatch({
            type: LOADING,
          });
          dispatch({
            type: action,
            request: fromJS(data),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: FAILED,
          error: err,
        });
      });
  };
}

export function getTotalCounts(payload) {
  return (dispatch) => {
    dispatch({
      type: GET_TOTAL_COUNTS_REQUESTED,
    });
    dispatch({
      type: GET_TOTAL_COUNTS_REQUESTED_PROFILE,
    });
    service.totalCountsForDashboard(payload)
            .then((data) => {
              if (data) {
                dispatch({
                  type: GET_TOTAL_COUNTS_SUCCESSFULL,
                  data,
                });
                dispatch({
                  type: GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE,
                  data,
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: GET_TOTAL_COUNTS_FAILED,
                error: err,
              });
              dispatch({
                type: GET_TOTAL_COUNTS_FAILED_PROFILE,
                error: err,
              });
            });
  };
}

export function addStudentCurrentDivision(payload) {
  return (dispatch) => {
    dispatch({
      type: ADD_CURRENT_DIVISION_REQUESTED,
    });
    service.addStudentCurrentDivision(payload)
      .then((data) => {
        dispatch({
          type: ADD_STUDENT_CURRENT_DIVISION,
          data,
        });
      })
      .catch((err) => {
        dispatch({
          type: ADD_CURRENT_DIVISION_FAILED,
          error: err,
        });
      });
  };
}

export function getRequestsViewedCount(payload) {
  return (dispatch) => {
    dispatch({
      type: REQUEST_VIEWED_COUNT_REQUESTED,
    });
    service.getTotalRequestViewedCount(payload)
      .then((data) => {
        dispatch({
          type: REQUEST_VIEWED_COUNT_SUCCESSFUL,
          data,
        });
      })
      .catch((err) => {
        dispatch({
          type: REQUEST_VIEWED_COUNT_FAILED,
          error: err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/DashboardView/actions.js